module.exports = __webpack_public_path__ + "assets/67504882a1094a0d05363eab198942d8.woff";